import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-funfacts-two',
  templateUrl: './funfacts-two.component.html',
  styleUrls: ['./funfacts-two.component.scss']
})
export class FunfactsTwoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
